<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >Gabarit de courriel personnalisé</span>
  </span>
  <el-form class="formContainer" :model="this.model" :rules="rules" ref="form">
    <el-row>
      <el-col>
        <el-form-item label="Type" prop="type_id">
          <el-select
            v-model="model.type_id"
            placeholder="Sélectionner"
            filterable
            @change="handleTypeChange">
            <el-option
              v-for="type in types"
              :key="type.id"
              :label="$t('email_custom_content.types.'+type.code)"
              :value="type.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item label="Description" prop="description">
          <el-input v-model="model.description"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item label="Contenu personnalisé">
          <br>
          <el-tabs v-model="languageTabs" type="border-card" v-if="model.content!=null" @tab-click="handleClickTab">
            <el-tab-pane v-for="l in languages" :key="l.id" :label="l.name" :name="l.code">
              <quill-editor v-model="model.content[l.code]" style="margin-top:40px;border:1px solid #EBEEF5;min-height:200px;"
                ref="noteEditor"
                :options="editorOptions">
              </quill-editor>
            </el-tab-pane>
          </el-tabs>

        </el-form-item>
      </el-col>
    </el-row>
  </el-form>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closeDialog">Annuler</el-button>
    <el-button type="primary" @click="save">Enregistrer</el-button>
  </span>
  </el-dialog>
</template>
<script>

import { mapActions, mapState, mapGetters } from 'vuex';
import eccAPI from '@/services/API/emailCustomContent'


export default {
  name: 'EmailCustomContentDialog',
	props: {
		emailContentTypeToEdit : null,
    visible : Boolean
	},
  data() {
    return {
      rules : {
        type_id : [
  	  		 	{ required: true, message: 'Veuillez sélectionner un type', trigger: 'blur' }
  	  		],
        description : [
  	  		 	{ required: true, message: 'Veuillez sélectionner une description', trigger: 'blur' }
  	  		]
      },
      model : {
        id : null,
        type_id : null,
        content : null,
        description : null
      },
      types : [],
      editorOptions: {
				theme: 'bubble',
        placeholder:"",
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link']
					]
				}
			},
      fullScreenLoading:false,
      languageTabs : "fr",
    };
  },components: {

  },
	methods: {
    handleClickTab(tab){
      // this.$refs.noteEditor.quill.focus();
    },
    handleTypeChange(type){

    },
    closeDialog(){
      this.$emit('close');
    },
    post(){
      eccAPI.post(this.model)
        .then(eccCreated=>{
          this.$emit('created',eccCreated);
          this.$message({
            message: 'Le gabarit personnalisé a été enregistré avec succès!',
            type: 'success'
          });
          this.$emit('close');
        }).catch(err=>{
          this.$message({
            message: 'Une erreur système est survenue. Veuillez réessayer plus tard!',
            type: 'error'
          });
        })
    },
    put(){
      eccAPI.put(this.model)
        .then(eccUpdated=>{
          this.$emit('updated',eccUpdated);
          this.$message({
            message: 'Le gabarit personnalisé a été modifié avec succès!',
            type: 'success'
          });
          this.$emit('close');
        }).catch(err=>{
          this.$message({
            message: 'Une erreur système est survenue. Veuillez réessayer plus tard!',
            type: 'error'
          });
        })
    },
    save(){
        this.$refs['form'].validate((valid)=>{
          if(valid){
            if(!this.isEditionMode){
              this.post();
            }else{
              this.put();
            }
          }
        });
    },
    fetchTypes(){
      return eccAPI.fetchTypes()
        .then(types=>{
          this.types = types;
          if(this.types.length==1){
            this.model.type_id=this.types[0].id;
          }
          return this.types;
        })
    },
    open(){
      this.fullScreenLoading=true;
      this.model.type_id=null;
      this.model.description = null;
      Promise.all([
          this.fetchTypes(),
          this.fetchLanguages()
            .then(()=>{
              this.model.content = {};
              _.forEach(this.languages, l=>{
                this.model.content[l.code] = null;
              })
              return null;
            })
      ]).then(()=>{
          if(this.emailContentTypeToEdit){
            Object.assign(this.model, this.emailContentTypeToEdit);
          }
          this.fullScreenLoading=false;
        })

    },
    ...mapActions('controlData',['fetchLanguages']),
	},
	computed: {
    isEditionMode(){
      return this.emailContentTypeToEdit!=null;
    },
    ...mapState('controlData',['languages']),
	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}


.formContainer{
    margin-left:30%;
    width:50%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:20%;
      width:60%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:15%;
      width:70%;
    }
}

</style>
